import getStore from 'module/store/get';

import socket from 'module/socket';
import eventBus from 'module/eventBus';

import {EVENT_ELECTRON_STORE_DISPATCH} from 'module/constants';

const store = getStore(require.context('./modules/', true, /index.js$/), null, (moduleName, storeModule) => {
  Object.keys(storeModule.actions).forEach((action) => {
    if(action.substring(0, 6) === 'socket'){
      socket.addAction(moduleName, action);
    }
  });
});

if (global.ipcRenderer) {
  global.ipcRenderer.on(EVENT_ELECTRON_STORE_DISPATCH, (event, {action, payload, responseChannel}) => {
    let promise = store.dispatch(action, payload);

    promise = promise || Promise.resolve();

    promise.then((data) => {
      if (responseChannel && responseChannel.success) {
        global.ipcRenderer.send(responseChannel.success, data);
      }
    }, (err) => {
      console.log('Action Failed', err);
      if (responseChannel && responseChannel.error) {
        global.ipcRenderer.send(responseChannel.error);
      }
    });
  });
}

eventBus.$emit('store', store);

socket.setStore(store);

export default store;
